export function CustomDomain(model = {}) {
  return {
    ownable: model?.ownable ? CustomDomainOwnable(model.ownable) : null,
    domain: model?.domain,
    default: model?.default,
    id: model?.id,
    createdAt: model?.createdAt
  };
}

export function setCustomDomainFromRequest(raw = {}) {
  const model = CustomDomain();

  model.id = raw?.id;
  model.domain = raw?.domain;
  model.default = raw?.default;
  model.createdAt = raw?.created_at;

  if (raw?.ownable) {
    model.ownable = setCustomDomainOwnableFromRequest(raw.ownable);
  }

  return model;
}

function CustomDomainOwnable(model = {}) {
  return {
    id: model?.id,
    name: model?.name,
    type: model?.type
  };
}

function setCustomDomainOwnableFromRequest(raw = {}) {
  const model = CustomDomainOwnable();

  model.id = raw?.id;
  model.name = raw?.name;
  model.type = raw?.type;

  return model;
}
